module.exports = __webpack_public_path__ + "static/media/stream-play_img.2882f389.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stream-play_img.svg
// module id = 915
// module chunks = 7